/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlock_Tree_Confirm_TitleInputs */

const en_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock this tree species?`)
};

const ar_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل تريد فتح أنواع الأشجار هذه؟`)
};

const de_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Baumart freischalten?`)
};

const es_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Desbloquear esta especie de árbol?`)
};

const fr_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voulez-vous débloquer cet arbre ?`)
};

const it_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sbloccare questa specie?`)
};

const ja_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この樹種をアンロックしますか？`)
};

const ko_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`해당 나무를 획득하시겠습니까?`)
};

const pt_br_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear essa espécie?`)
};

const ru_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокировать этот вид дерева?`)
};

const th_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกพันธุ์ต้นไม้นี้หรือไม่?`)
};

const tr_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu ağaç türünün kilidini aç?`)
};

const zh_cn_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁此树种？`)
};

const zh_tw_unlock_tree_confirm_title = /** @type {(inputs: Unlock_Tree_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解鎖此樹種？`)
};

/**
* | output |
* | --- |
* | "Unlock this tree species?" |
*
* @param {Unlock_Tree_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const unlock_tree_confirm_title = /** @type {((inputs?: Unlock_Tree_Confirm_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlock_Tree_Confirm_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlock_tree_confirm_title(inputs)
	if (locale === "ar") return ar_unlock_tree_confirm_title(inputs)
	if (locale === "de") return de_unlock_tree_confirm_title(inputs)
	if (locale === "es") return es_unlock_tree_confirm_title(inputs)
	if (locale === "fr") return fr_unlock_tree_confirm_title(inputs)
	if (locale === "it") return it_unlock_tree_confirm_title(inputs)
	if (locale === "ja") return ja_unlock_tree_confirm_title(inputs)
	if (locale === "ko") return ko_unlock_tree_confirm_title(inputs)
	if (locale === "pt_br") return pt_br_unlock_tree_confirm_title(inputs)
	if (locale === "ru") return ru_unlock_tree_confirm_title(inputs)
	if (locale === "th") return th_unlock_tree_confirm_title(inputs)
	if (locale === "tr") return tr_unlock_tree_confirm_title(inputs)
	if (locale === "zh_cn") return zh_cn_unlock_tree_confirm_title(inputs)
	return zh_tw_unlock_tree_confirm_title(inputs)
});